/**
 * Clamp value within range between min & max
 * @param val
 * @param min
 * @param max
 * @returns
 */
export const clamp = (val: number, min: number, max: number): number => Math.min(Math.max(val, min), max);
